module.exports = __webpack_public_path__ + "files/1778883365bad5f95d001fc21b12ce40.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/ubuntu-bold-webfont.woff2
// module id = 785
// module chunks = 60